import { defineMessages } from 'react-intl-next';

const PREFIX = 'ptc.pt';

export const messages = defineMessages({
	// member pickers
	limitedUsersInvitationMessageInfo: {
		id: `${PREFIX}.member-picker.msg.exceed.limited.number.info`,
		defaultMessage: `You can invite up to {maxNumber, plural, \
      one {1 person} \
      other {{maxNumber} people}} \
      at once.`,
		description: 'A info message which always shows beneath of the user select box',
	},
	limitedUsersInvitationMessageError: {
		id: `${PREFIX}.member-picker.error.msg.exceed.limited.number.error2`,
		defaultMessage: `You've entered more than {maxNumber, plural, \
      one {{maxNumber} person} \
      other {{maxNumber} people}}.`,
		description:
			'A error message which shows beneath of the user select box when users enter more than maximum items (ex: 10)',
	},
	limitedUsersInvitationMessageMaximumError: {
		id: `${PREFIX}.member-picker.error.msg.reach.limited.number.error`,
		defaultMessage: `You can only invite up to {maxNumber, plural, \
      one {{maxNumber} person} \
      other {{maxNumber} people}} at once.`,
		description:
			'A error message which shows beneath of the user select box when the number of the selected users reaches maximum',
	},
	userPickerPlaceholder: {
		id: `${PREFIX}.member-picker.placeholder`,
		defaultMessage: 'Choose people',
		description: 'The empty search box for a user to begin typing',
	},
	userPickerPlaceholderNext: {
		id: `${PREFIX}.member-picker.placeholder.next`,
		defaultMessage: 'Search for team members',
		description: 'The empty search box for a user to begin typing',
	},
	userPickerNoOption: {
		id: `${PREFIX}.member-picker.no-option`,
		defaultMessage: 'No matches.',
		description: 'No search results found, and invite is not available',
	},
	userPickerNoOptionWithEmailSuggestion: {
		id: `${PREFIX}.member-picker.no-option-with-email-suggestion`,
		defaultMessage: 'Enter an email address',
		description: 'No search results found, but invite is available',
	},
	enterMore: {
		id: `${PREFIX}.member-picker.enter-more`,
		defaultMessage: 'Enter more',
		description: 'A label prompting users to enter more users when they have already selected some',
	},
	// team-create-dialog
	modalTitle: {
		id: `${PREFIX}.team-create-dialog.title`,
		defaultMessage: 'Create a team',
		description: 'Title of the modal for inviting members to a team',
	},
	modalTitleNext: {
		id: `${PREFIX}.team-create-dialog.title.next`,
		defaultMessage: 'Create team',
		description: 'Title of the modal for inviting members to a team',
	},
	modalTitleIconLabel: {
		id: `${PREFIX}.team-create-dialog.title`,
		defaultMessage: 'Teams icon',
		description: 'Icon for the title of the modal for inviting members to a team',
	},
	formTextWithMention: {
		id: `${PREFIX}.team-create-dialog.pretext.with.mention`,
		defaultMessage: `Bring everyone together with one team you can @mention, filter, and assign work to. {learnMoreLink}`,
		description: 'Intro text that goes before form inputs (which hints about mentions as well)',
	},
	requiredFieldSummary: {
		id: `${PREFIX}.team-create-dialog.required-field.summary`,
		defaultMessage: 'Required fields are marked with an asterisk',
		description: 'Summary info of required fields asterisk.',
	},
	teamNameFieldLabel: {
		id: `${PREFIX}.team-create-dialog.team-name-field.label`,
		defaultMessage: 'Team name',
		description: 'Label of the field to input team name in Team Create modal',
	},
	teamNameFieldLabelNext: {
		id: `${PREFIX}.team-create-dialog.team-name-field.label.next`,
		defaultMessage: 'Name',
		description: 'Label of the field to input team name in Team Create modal',
	},
	teamNameFieldPlaceholder: {
		id: `${PREFIX}.team-create-dialog.modal.team-name-field.placeholder`,
		defaultMessage: 'e.g. HR Team, Redesign Project, Team Mango',
		description: 'Placeholder of the team name field in the Team Create modal',
	},
	teamNameFieldRequiredErrorMessage: {
		id: `${PREFIX}.team-create-dialog.modal.team-name-field.required.error-message`,
		defaultMessage: 'You must provide a team name',
		description:
			'Error message of the field team name in Team Create modal when the input is empty',
	},
	teamNameFieldTooLongErrorMessage: {
		id: `${PREFIX}.team-create-dialog.modal.team-name-field.too-long.error-message`,
		defaultMessage: 'Team name must be 100 characters or less',
		description:
			'Error message of the field team name in Team Create modal when the team name is too long',
	},
	teamNameFieldInfoMessage: {
		id: `${PREFIX}.team-create-dialog.modal.team-name-field.info-message`,
		defaultMessage: 'Who can see your team name?',
		description:
			'Info message of the field team name in Team Create modal to inform the visibility',
	},
	teamNameFieldInfoDetail: {
		id: `${PREFIX}.team-create-dialog.modal.team-name-field.info-detail`,
		defaultMessage:
			'Your team name is visible to anyone in your organisation. It may be visible on work shared outside your organisation.',
		description: 'Detail message of the field team name on popup to inform the visibility',
	},
	submitButtonLabel: {
		id: `${PREFIX}.team-create-dialog.button.submit`,
		defaultMessage: 'Create a team',
		description:
			'A main button in Team Create Dialog. Clicking on it will create a new team and close the dialog',
	},
	submitButtonLabelNext: {
		id: `${PREFIX}.team-create-dialog.button.submit.next`,
		defaultMessage: 'Create',
		description:
			'A main button in Team Create Dialog. Clicking on it will create a new team and close the dialog',
	},
	cancelButtonLabel: {
		id: `${PREFIX}.team-create-dialog.button.cancel`,
		defaultMessage: 'Cancel',
		description:
			'A main button in Team Create Dialog. Clicking on it to close the dialog without creating a team',
	},
	learnMore: {
		id: `${PREFIX}.team-create-dialog.learn-more`,
		defaultMessage: 'What’s a team?',
		description:
			'A link to https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-team/ for more information on what a team is',
	},
	backButton: {
		id: `${PREFIX}.team-create-dialog.button.back`,
		defaultMessage: 'Go back',
		description: 'A button to go back to the previous step',
	},
	// flags of team-create-dialog
	flagSuccessCreateTeamTitle: {
		id: `${PREFIX}.team-create-dialog.flag-success.title`,
		defaultMessage: 'Team has been created',
		description: 'A title of a success flag appearing when creating team succeeds',
	},
	flagSuccessCreateTeamDesc: {
		id: `${PREFIX}.team-create-dialog.flag-success.desc`,
		defaultMessage:
			'Start collaborating by @mentioning the team’s name, or view the team’s profile.',
		description: 'A description of a success flag appearing when creating team succeeds',
	},
	flagSuccessCreateTeamAction: {
		id: `${PREFIX}.team-create-dialog.flag-success.action`,
		defaultMessage: 'View team',
		description:
			'An link in success flag appearing when creating team succeeds. Clicking on it will go to the team profile page',
	},
	flagErrorCreateTeamTitle: {
		id: `${PREFIX}.team-create-dialog.flag-error.title`,
		defaultMessage: 'Sorry, something went wrong',
		description: 'A title of an error flag appearing when creating team fails',
	},
	flagErrorCreateTeamDesc: {
		id: `${PREFIX}.team-create-dialog.flag-error.desc`,
		defaultMessage: "We couldn't save your team. Please try again.",
		description: 'A description of an error flag appearing when creating team fails',
	},
	flagErrorCreateTeamPartialFailTitle: {
		id: `${PREFIX}.team-create-dialog.flag-partial-error.title`,
		defaultMessage: 'Sorry, something went wrong',
		description: 'A title of an error flag appearing when inviting some members fails',
	},
	flagErrorCreateTeamPartialFailDesc: {
		id: `${PREFIX}.team-create-dialog.flag-partial-error.desc`,
		defaultMessage: "We couldn't invite some members. Please try again.",
		description: 'A description of an error flag appearing when inviting some members fails',
	},
	// inviting members
	invitationsFieldLabel: {
		id: `${PREFIX}.team-create-dialog.modal.fields.invite-emails.label`,
		defaultMessage: 'Who should be in this team?',
		description: 'Label of the field invite emails in Team Create modal',
	},
	invitationsFieldLabelNext: {
		id: `${PREFIX}.team-create-dialog.modal.fields.invite-emails.label.next`,
		defaultMessage: 'Add team members',
		description: 'Label of the field invite emails in Team Create modal',
	},
	invitationsFieldErrorMessage: {
		id: `${PREFIX}.team-create-dialog.modal.fields.invite-emails.error-message`,
		defaultMessage:
			'Teams must contain at least one member. You can invite up to {maxSelectedMembers, plural, one {# person} other {# people}} at a time.',
		description:
			'Error message of the field invitation in Team Create modal when the input is empty',
	},
	invitationsFieldErrorMessageNext: {
		id: `${PREFIX}.team-create-dialog.modal.fields.invite-emails.error-message.next`,
		defaultMessage: 'You must add at least one team member',
		description:
			'Error message of the field invitation in Team Create modal when the input is empty',
	},
	// team membership control
	teamTypePickerLabel: {
		id: `${PREFIX}.team-type-picker.field.label`,
		defaultMessage: 'Membership controls',
		description:
			'The label for the field allowing you to choose the membership control for the newly created team',
	},
	new: {
		id: `${PREFIX}.team-type-picker.field.new.lozenge`,
		defaultMessage: 'New',
		description:
			'Lozenge in the membership controls field shown for the first 2 months to attract attention to the field',
	},
	teamTypeCheckboxLabel: {
		id: `${PREFIX}.team-type-picker.checkbox.label`,
		defaultMessage: 'Anyone can join this team without approval',
		description: 'The label for the checkbox describing the team membership setting',
	},
	openTeam: {
		id: `${PREFIX}.team-type-picker.team-type.open`,
		defaultMessage: 'Open team',
		description: 'The label for the option to make your team open',
	},
	inviteOnlyTeam: {
		id: `${PREFIX}.team-type-picker.team-type.invite-only`,
		defaultMessage: 'Invite-only team',
		description: 'The label for the option to make your team invite-only',
	},
	openTeamDescription: {
		id: `${PREFIX}.team-type-picker.team-type.open.description`,
		defaultMessage: 'Anyone in your organisation can join and edit the team.',
		description:
			'A description for the option for an open team, explaining roughly what an open team means',
	},
	inviteOnlyTeamDescription: {
		id: `${PREFIX}.team-type-picker.team-type.invite-only.description`,
		defaultMessage:
			'Anyone in your organisation can request to join and must be approved by a current team member.',
		description:
			'A description for the option for an invite-only team, explaining roughly what an invite-only team means',
	},
	noAccessErrorStateTitle: {
		id: `${PREFIX}.team-create-dialog.no-access-error.title`,
		defaultMessage: "We can't create your team",
		description: 'The title for no access error state',
	},
	noAccessErrorStateMessage: {
		id: `${PREFIX}.team-create-dialog.no-access-error.description`,
		defaultMessage: "You don't have access to create teams in this organization.",
		description: 'The message for no access error state',
	},
	noAccessErrorStateActionLabel: {
		id: `${PREFIX}.team-create-dialog.no-access-error.action-label`,
		defaultMessage: 'OK',
		description: 'The action label for no access error state',
	},
	experimentProductSelectorFieldLabel: {
		id: `${PREFIX}.team-create-dialog.experiment.product-selector-field.label`,
		defaultMessage: 'What apps do they need access to?',
		description: 'The label of the product selector',
	},
	experimentProductSelectorFieldInfoDetail: {
		id: `${PREFIX}.team-create-dialog.experiment.product-selector-field.info-detail`,
		defaultMessage:
			"Select from this list of Atlassian apps used by your organization. The addition of any new licenses may affect billing.{br}If you're not an admin, your app requests will be sent to one for approval.{br}Access to these apps will not be automatically granted for future members added to this team.",
		description:
			'Detail message of the field team name on popup to inform the visibility. {br} is the linebreak variable and should not be removed.',
	},
	teamProductAccessFlagInformInviteToProductsTitle: {
		id: `${PREFIX}.team-create-dialog.experiment-flag-invite-to-products-informing.title`,
		defaultMessage: 'App access requested',
		description:
			'A title of an informing flag appearing when creating team and inviting members to products request sent',
	},
	teamProductAccessFlagInformInviteToProductsDesc: {
		id: `${PREFIX}.team-create-dialog.experiment-flag-invite-to-products-informing.desc`,
		defaultMessage:
			`All members should receive an email confirming their access to selected products. {br}` +
			"If you're not an admin, your product requests may be sent to one for approval.",
		description:
			'A description of an informing flag appearing when creating team and inviting members to products request sent',
	},
	// create containers
	createContainersLabel: {
		id: `${PREFIX}.team-create-dialog.create-containers.label`,
		defaultMessage: 'Add new team spaces',
		description: 'The label for the field allowing you to choose the spaces to create for the team',
	},
	createContainersInfo: {
		id: `${PREFIX}.team-create-dialog.create-containers.info`,
		defaultMessage:
			'Spaces will be made matching this team’s name and will be automatically linked.',
		description: 'The info for the field allowing you to choose the spaces to create for the team',
	},
	createContainersJira: {
		id: `${PREFIX}.team-create-dialog.create-containers.jira`,
		defaultMessage: 'Jira project',
		description: 'The label for the Jira project',
	},
	createContainersConfluence: {
		id: `${PREFIX}.team-create-dialog.create-containers.confluence`,
		defaultMessage: 'Confluence space',
		description: 'The label for the Confluence space',
	},
	createContainersLoom: {
		id: `${PREFIX}.team-create-dialog.create-containers.loom`,
		defaultMessage: 'Loom space',
		description: 'The label for the Loom space',
	},
	skeletonItemLoading: {
		id: `${PREFIX}.skeleton-item.loading`,
		defaultMessage: 'Menu item is loading',
		description: 'The message that screen reader announces when a menu item is loading',
	},
});
